import dayjs from "dayjs";
import { array, date, object, string } from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  goodsReceiptProductVariants: [],
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().required("Harus diisi"),
  warehouse: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  sellerReferenceNumber: string().required("Harus diisi"),
  goodsReceiptProductVariants: array()
    .of(object().shape({})) // Ensures each item is an object (can be expanded with more validation)
    .min(1, "Harus memiliki setidaknya satu produk"), // ✅ Ensures at least 1 item
});
